export const queryKeys = {
  profile: ['profile'] as const,
  calls: ['calls'] as const,
  callsSearch: (q: string) => ['calls', 'search', q] as const,
  call: (sid: string) => ['call', sid] as const,
  callDetails: (sid: string) => ['call', sid, 'details'] as const,
  voices: ['voices'] as const,
  subscription: ['subscription'] as const,
  businessSubscription: ['subscription', 'business'] as const,
  /** Under `subscription` so the billing pushes that invalidate it refresh this too. */
  customerInfo: (uid: string) => ['subscription', 'customer', uid] as const,
  business: ['business'] as const,
  contacts: ['contacts'] as const,
  keys: ['keys'] as const,
  feed: ['feed'] as const,
  price: (e164: string, advanced: boolean, record?: boolean) =>
    ['price', e164, advanced, record] as const,
}
